import React, { useState } from 'react'
import "./../styles/about.css";
import "./../styles/home.css";


import { Link } from 'react-router-dom'
import Ad from '../Ad';

const About = () => {

    return (
        <div>
            <section className='about-header'>
                <h1>ABOUT BETWEEN CHOIRS</h1>
                <div id='about-header-image' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/about-bg3.png)` }}>

                </div>
            </section>



            <section className='who-are-we'>
                <h2>Who Are We?</h2>
                <div id='who-are-we-line'></div>
                <p >
                    Welcome to Between Choirs, an electrifying creation by ScholarshipAuditions.com! We’ve reimagined those moments “between” show choir performances, transforming them into a vibrant realm of entertainment, exploration, and connection.</p>
                <br />
                <p>Show choir competitions are packed with breathtaking performances, but the stretches of downtime between acts can sometimes feel endless. That’s where we come in! Our mission is simple: to elevate every moment of your show choir experience. From engaging articles that dive deep into the dazzling world of show choirs to an exciting lineup of games and activities, Between Choirs turns waiting time into a celebration of music, artistry, and community.</p>
                <br />
                <p>
                    But we’re more than just entertainment. We’re a tribute to the extraordinary talent and dedication that make show choirs a source of inspiration and joy. Whether you're a performer, a parent, or a fan, Between Choirs offers a uniquely crafted experience to keep the energy high and the spirit alive.
                </p>
                <br />
                <p>
                    So, get ready to immerse yourself in a space that’s as captivating as the stage itself. Let’s make every moment unforgettable—Between Choirs.
                </p>
            </section>

            <section id='what-we-offer'>
                <h4>What do we offer?</h4>
                <div id='what-we-offer-line'></div>
                <div id='about-cards'>
                    <div className='about-card'>
                        <div className='about-card-title'>
                            <img src={process.env.PUBLIC_URL + 'images/article-icon.png'} height='35px'></img>
                            <h3 id='artic'>Articles</h3>
                            <div className='abt-crd-line'></div>
                        </div>
                        <p>Explore a diverse array of articles to enjoy during your downtime! From the fascinating history of show choirs to behind-the-scenes insights on how competitions are judged, there’s something for everyone. Immerse yourself in the world of show choirs while you wait!</p>
                        <Link style={{ textDecoration: 'none', width: '100%' }} to='/articlespage'>
                            <button className='gold-gradient-wshimmer'>Read</button>
                        </Link>

                    </div>
                    <div className='about-card'>
                        <div className='about-card-title'>
                            <img src={process.env.PUBLIC_URL + 'images/controller-purple.png'} height='35px'></img>
                            <h3>Games</h3>
                            <div className='abt-crd-line'></div>
                        </div>
                        <p>Stay entertained between sets with our exciting lineup of games! From a fresh twist on tic-tac-toe to challenging crossword puzzles and a trivia quiz that puts your show choir knowledge to the test, we’ve got plenty to keep the fun going between performances.</p>
                        <Link style={{ textDecoration: 'none', width: '100%' }} to='/games' >
                            <button className='gold-gradient-wshimmer'>Play</button>
                        </Link>

                    </div>
                    <div className='about-card'>
                        <div className='about-card-title'>
                            <img src={process.env.PUBLIC_URL + 'images/activities-icon.png'} height='35px'></img>
                            <h3>Activities</h3>
                            <div className='abt-crd-line'></div>
                        </div>
                        <p>Beyond games, we offer a variety of activities to spark your creativity and keep you engaged. Unleash your artistic side with our coloring book or put your observation skills to the test with an exciting scavenger hunt. There’s something for everyone to enjoy!</p>

                        <Link style={{ textDecoration: 'none', width: '100%' }} to='/activitiespage'>
                            <button className='gold-gradient-wshimmer'>Play</button>
                        </Link>
                    </div>
                </div>
            </section>



            <Ad />
        </div>
    )
}

export default About
